
        module.exports = __webpack_public_path__ + "assets/images/smeunited-logo.9cc9aee7.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 335,
            height: 199,
            type: "svg",
            bytes: 9965,

            toString: function() {
                return src;
            }
        };
    